// extracted by mini-css-extract-plugin
export default {"RoutesWrapper":"App_RoutesWrapper__+uccz"};